import {useCallback} from 'react';
import useDiToggleTags from './useDiToggleTags';
import {apiAddDataItemSegmentTag, apiRemoveDataItemSegmentTag} from '../../utils/api/tags';

/**
 * Tags for one My Data sentence segment (data_item_segments row) — toggle model on
 * data_item_segment_tag_link. Disabled (no-op) when dataItemSegmentId is null.
 */
export default function useDataItemSegmentTags({dataItemSegmentId, initialTags}) {
    const addFn = useCallback(
        ({name, userId}) => apiAddDataItemSegmentTag({segmentId: dataItemSegmentId, name, userId}),
        [dataItemSegmentId]);
    const removeFn = useCallback(
        ({name, userId}) => apiRemoveDataItemSegmentTag({segmentId: dataItemSegmentId, name, userId}),
        [dataItemSegmentId]);

    return useDiToggleTags({
        enabled: dataItemSegmentId != null,
        initialTags,
        addFn,
        removeFn,
    });
}
